module.exports = __webpack_public_path__ + "static/media/inbox-outline.9b5403f8.svg";